import { type ComboboxOption } from "@ubud-ui/react-ui-kit";
import { z } from "zod";

export const companyEmployerRegistrationSchema = z.object({
  wlkp_code: z
    .string()
    .min(1, "Kode WLKP harus diisi")
    .regex(
      /^\d{5}\.\d{5}\.\d{8}\.\d-\d{3}$/,
      "Format kode WLKP belum sesuai"
    ),
  industry: z
    .looseObject<ComboboxOption>({} as ComboboxOption, "Industri harus dipilih").nullable(),
  referral_code: z.string().optional(),
});

export type CompanyEmployerRegistrationDto = z.infer<
  typeof companyEmployerRegistrationSchema
>;

export interface CompanyEmployerRegistrationResponse {
  data: {
    id: string;
    name: string;
    email: string;
    username?: string;
    [key: string]: unknown;
  };
}
